// extracted by mini-css-extract-plugin
export default {"cell":"cell--v0irI","cell__content":"cell__content--7PT8w","cellContent":"cell__content--7PT8w","cell__image":"cell__image--leNyX","cellImage":"cell__image--leNyX"};